import { FC } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

import styles from './collection.module.scss';

import ImgEmptyCollection from '../../../../../assets/images/empty-collection.svg';
import { togglePopup } from '../../../../../store/ui';
import Button, { ButtonKind } from '../../button/Button';

const CollectionEmpty: FC<{ isEmptyCollection: boolean }> = ({ isEmptyCollection }) => {
    const dispatch = useDispatch();
    const intl = useIntl();

    if (isEmptyCollection) {
        return (
            <div className={styles.emptyCollection}>
                <h4>{intl.formatMessage({ id: 'collection.title', defaultMessage: 'Ihre Auswahl' })}</h4>

                <p className={styles.subTitle}>
                    {intl.formatMessage({
                        id: 'collection.subTitle',
                        defaultMessage: 'Erstellen Sie Ihre personalisierte Standortliste',
                    })}
                </p>

                <img src={ImgEmptyCollection} alt="Collection empty" />

                <p>
                    {intl.formatMessage({
                        id: 'collection.locationText',
                        defaultMessage: 'Hinzugefügte Standorte werden hier angezeigt.',
                    })}
                </p>

                <p>
                    {intl.formatMessage({
                        id: 'collection.createListText',
                        defaultMessage: 'Erstellen Sie Ihre Liste, teilen Sie sie und laden Sie sie als PDF herunter.',
                    })}
                </p>

                <div className={styles.acceptButtonWrap}>
                    <Button
                        className={styles.acceptButton}
                        kind={ButtonKind.INVERT}
                        onClick={() => dispatch(togglePopup({ name: 'collection', status: false }))}
                    >
                        {intl.formatMessage({ id: 'collection.okButton', defaultMessage: 'Ok, habe es verstanden' })}
                    </Button>
                </div>
            </div>
        );
    }

    return null;
};

export default CollectionEmpty;
